'use client';

import React, { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';

interface LastUpdatedProps {
  fetchedAt: string;
}

export default function LastUpdated({ fetchedAt }: LastUpdatedProps) {
  const [displayTime, setDisplayTime] = useState('');

  useEffect(() => {
    const d = new Date(fetchedAt);
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const seconds = String(d.getSeconds()).padStart(2, '0');
    setDisplayTime(`${hours}:${minutes}:${seconds}`);
  }, [fetchedAt]);

  return (
    <div className="flex items-center gap-2 text-xs text-muted-foreground pb-4">
      <Clock size={12} strokeWidth={2} />
      <span>
        Zuletzt aktualisiert:{' '}
        <span className="font-tabular text-foreground/70">
          {displayTime || '—'}
        </span>
        {' '}· Datenquelle:{' '}
        <a
          href="https://energy-charts.info"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary hover:underline"
        >
          Fraunhofer ISE Energy-Charts
        </a>
        {' '}· Day-Ahead Markt · Gebotszone DE-LU
      </span>
    </div>
  );
}